<template>
  <div class="filter">
    <h6 v-if="filter.title" class="filter-title">{{ filter.title }}</h6>
    <div
      v-for="(param, index) of filter.values"
      :key="index"
      class="filter-params"
    >
      <checkbox
        v-if="param.name && filter.type === 'checkbox'"
        @click.native="$emit('activateFilter', param)"
        :text="param.name"
        :isChecked="isActivated(param.queryParam)"
        class="param"
      />
      <radio-button
        v-if="param.name && filter.type === 'radio'"
        @click.native="$emit('activateFilter', param)"
        :text="param.name"
        :isChecked="isActivated(param.queryParam)"
        class="param"
      />
    </div>
  </div>
</template>

<script>
import checkbox from '@/components/library/checkbox'
import radioButton from '@/components/library/radioButton'

export default {
  props: {
    filter: {
      type: Object,
      required: true,
    },
    activatedFilter: {
      type: String,
    },
  },
  methods: {
    isActivated(param) {
      return this.activatedFilter === param
    },
  },
  components: {
    checkbox,
    'radio-button': radioButton,
  },
}
</script>

<style lang="scss">
.filter {
  &,
  &-params {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  &-title {
    height: 18px;
    font-size: 12px;
    line-height: 18px;
    color: #9d9dbc;
    margin-bottom: -2px;
  }
  &-params {
    .param {
      height: 24px;
      cursor: pointer;
    }
  }
}

#app[data-theme='dark'] {
  .filter {
    &-title {
      color: #9d9dbc !important;
    }
    &-params {
      .param {
        color: #d6d6d6;
      }
    }
  }
}
</style>
